import React from 'react';
import { RecycleSymbol } from './styled';

interface HiddenReusableIndicatorProps {
  published: boolean;
  reusable_packaging: boolean;
}

function HiddenReusableIndicator({
  published,
  reusable_packaging,
}: HiddenReusableIndicatorProps) {
  const symbols = [];
  if (!published) {
    symbols.push(<b>[hidden]</b>);
  }
  if (reusable_packaging) {
    if (symbols.length !== 0) symbols.push(' - ');
    symbols.push(<RecycleSymbol />);
  }
  if (symbols.length === 0) return null;

  return <span>({symbols})</span>;
}

export default HiddenReusableIndicator;
